import { optionTitle_AgendaMail } from './AgendaMailOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
/**
 * Txp options settings
 */
let AgendaMailOption: LazyOption = createLazyOption(
    {
        key: 'agenda',
        titleStringKey: optionTitle_AgendaMail,
        searchTermsStringKey: optionTitle_AgendaMail,
        hideTitleInFullOptions: true,
        isHidden: () => !isConsumer() && !isFeatureEnabled('cal-mf-agendaMailOption'),
        allowedOptionKeys: ['AgendaMail'],
    },
    lazyFullModule,
    m => m.default
);
export default AgendaMailOption;
